export const LoginModalProperties = {
  class: "new-landing",
  title: "Вход в систему",
  width: 399,
};
export const RegistrationModalProperties = {
  class: "new-landing",
  title: "Регистрация",
  width: 399,
};
export const SuccessModalProperties = {
  class: "new-landing-success",
  title: "",
  width: 560,
};
export const PurchasesTableCustomFilterModalProperties = {
  class: "light",
  title: "Редактор фильтра",
  width: 1000,
  modalBodyNoPaddings: true,
};
export const PurchasesTableEditCustomFilterModalProperties = {
  class: "light",
  title: "Редактировать фильтр",
  width: 1000,
  modalBodyNoPaddings: true,
};
export const SubscriptionModalProperties = {
  class: "light",
  title: "Продление подписки",
  width: 1032,
  modalBodyNoPaddings: true,
};
export const ChangePasswordModalProperties = {
  class: "light",
  title: "Сменить пароль",
  width: 370,
};
export const OtherLotsModalProperties = {
  class: "light",
  title: "Список всех лотов в закупке",
  width: 470,
  modalBodyNoPaddings: true,
};
export const RecoveryPasswordModalProperties = {
  class: "new-landing",
  title: "Восстановить пароль",
  width: 399,
};
export const ConfirmModalProperties = {
  class: "dark",
  title: "",
  width: 352,
};
export const SubscriptionHistoryModalProperties = {
  class: "light",
  title: "История подписок",
  width: 1200,
};
export const SubscriptionDateModalProperties = {
  class: "light",
  title: "Продлить подписку",
  width: 502,
  modalBodyCustomPaddings: true,
};
export const ProxyModalProperties = {
  class: "light",
  title: "Список прокси",
  width: 1100,
};

export const TagsEditorModalProperties = {
  class: "light",
  title: "Редактор меток",
  width: 660,
  modalBodyTagsEditorPadding: true,
};

export const CallRequestModalProperties = {
  class: "new-landing",
  title: "Обратная связь",
  width: 399,
};

export const GetAccessModalProperties = {
  class: "new-landing",
  title: "Получить доступ",
  width: 399,
};

export const BitrixExportProperties = {
  class: "bitrix",
  title: "Отправить в Bitrix24",
  width: 1000,
};
export const DateRangeModalProperties = {
  class: "light",
  title: "Выберите период",
  width: 400,
  modalBodyCustomPaddings: true,
};
